import {Injectable, NgZone, inject} from '@angular/core';
import {Observable, of} from 'rxjs';
import {catchError, map, mergeMap, shareReplay, tap} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {GOOGLE_MAPS_API} from '../../_constants/constants';

export interface MapGeocoderResponse {
  status: google.maps.GeocoderStatus;
  results: google.maps.GeocoderResult[];
}

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {

  loadApi$: Observable<boolean>;

  private readonly httpClient = inject(HttpClient);
  private readonly _ngZone = inject(NgZone);  
  private _geocoder: google.maps.Geocoder;

  constructor() {
    this.loadApi$ = this.createApiLoader();
  }

  private createApiLoader(): Observable<boolean> {
    console.debug('_loadApi()');
    return this.httpClient.jsonp(`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API}`, 'callback')
      .pipe(
        map(() => {
          console.debug('loadApi() successful');
          //Create a Geocoder instance from the now loaded API js
          this._geocoder = new google.maps.Geocoder();
          return true;
        }),
        catchError(err => {
          console.error('loadApi() failure', err);
          return of(false);
        }),
        //Use share replay so that other subscribers don't trigger loading the API over and over again
        shareReplay(1)
      );
  }

  geocodeAddress(address: string): Observable<MapGeocoderResponse> {
    console.log(`Start geocoding! - ${address}`);

    //First check if the api is loaded, then return the observable that will do the geocoding
    return this.loadApi$.pipe(
      tap(loaded => console.debug('API loaded?', loaded)),
      mergeMap(() =>
        //This code snippet is only necessary until Angular 12, when it will be an injectable component
        //The code itself comes from here: https://github.com/angular/components/tree/master/src/google-maps/map-geocoder
        //See here (about it being in v12): https://github.com/angular/components/issues/21954
        new Observable<MapGeocoderResponse>(observer => {
          this._geocoder.geocode({address: address}, (results, status) => {
            this._ngZone.run(() => {
              observer.next({results, status});
              observer.complete();
            });
          });
        }))
    );
  }

}
